import PageWrapper from "app/components/page-wrapper/page-wrapper";
import { idoFilters, youtubeBridgeGuideLink } from "app/config";
import { campaignIds } from "app/enums";
import { FC } from "react";
import { useGetIdosQuery, useGetUserLeaderboardQuery } from "store/api/new.api";
import { useAccount } from "wagmi";
import FullScreenLoader from "../components/loader/FullScreenLoader";
import IdoProject from "../components/main-projects/IdoProject";
import { SeoHead } from "../components/SeoHead/SeoHead";
import {
  seoKeyWords,
  seoPageDescription,
  seoPageTitle,
  seoUrl,
} from "../config/SeoConfig";
import { useTheme } from "../shared";
import { INTEGRATOR } from "../utils/constants";
import { LiFi } from "../widgets/LiFi/LiFi";
import { useAuth } from "../hooks";

import styles from "./Bridge.module.scss";

const BridgePage: FC = () => {
  const { theme } = useTheme();
  const { address } = useAccount();
  const isAuth = useAuth();
  //@ts-ignore
  const { data: userTier, isLoading: userTierLoading } =
    useGetUserLeaderboardQuery(
      { platform: "web3", address: address as string, campaignIds },
      { skip: !isAuth || !address }
    );
  const { data: idos, isLoading } = useGetIdosQuery({
    address: address as string,
    page: 1,
    limit: 100,
  });

  if (userTierLoading || isLoading || !idos) {
    return <FullScreenLoader isLoading={userTierLoading} />;
  }

  return (
    <PageWrapper>
      <SeoHead
        title={seoPageTitle}
        description={seoPageDescription}
        url={seoUrl}
        keywords={seoKeyWords}
      />
      <div className={styles.main}>
        <div className={styles.content}>
          <div className={styles.wrapper}>
            <h1
              className={`${styles.title} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              Swap & Bridge Assets
            </h1>
            <div className={styles.textWrapper}>
              <p
                className={`${styles.text} ${
                  theme === "dark" ? styles.darkTheme : ""
                }`}
              >
                Easily swap or bridge assets across 30+ blockchains — fast,
                secure, and low-cost. Stay on AlphaMind, no extra steps, no
                switching platforms.
              </p>
            </div>
            <section aria-label="Cross-chain bridge interface">
              <LiFi
                variant="compact"
                integrator={INTEGRATOR}
                tier={userTier?.tier}
              />
            </section>
            {youtubeBridgeGuideLink && (
              <>
                <div className={styles.textWrapperSecondary}>
                  <p
                    className={`${styles.text} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    Not sure how to use the bridge? 👀
                  </p>
                  <p
                    className={`${styles.text} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    No worries — just watch the video below and get started in
                    seconds! 👇
                  </p>
                </div>
                <section
                  aria-label="Bridge Guide video"
                  className={styles.videoWrapper}
                >
                  <div className={styles.videoContainer}>
                    <iframe
                      src={youtubeBridgeGuideLink}
                      title="Bridge Guide video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </section>
              </>
            )}
            <section aria-label="Ongoing IDO projects">
              <IdoProject
                search={false}
                data={{ items: idos.list ?? [] }}
                title="Featured IDO Projects"
                description="Discover the latest Initial DEX Offerings on supported chains"
                filters={idoFilters}
              />
            </section>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default BridgePage;
